import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
// import { Trans } from 'react-i18next';
import type { QuestionInputField } from '/index';

import { useGetBusinessDocuments } from '/business/shared/hooks/useGetBusinessDocuments';
import useGetDefaultDistanceUnit from '/business/shared/hooks/useGetDefaultDistanceUnit';
import {
  ERR_TYPE_NUM_LARGE,
  ERR_TYPE_NUM_SMALL,
  ERR_TYPE_REQUIRED,
  ERR_TYPE_STR_LONG,
  ERR_TYPE_STR_SHORT,
  FIELD_TYPE_NUMBER,
  FIELD_TYPE_TXTAREA,
} from '/business/shared/components/questions/helper/fieldEnums';

// import { urlApplicationRoot } from '/business/shared/util/Statics.js';
// import StyledParagraph from '/shared/styled/components/StyledParagraph';
// import StyledFormLabel from '/shared/styled/form/StyledFormLabel.js';
// import LinkButton from '/shared/components/widgets/button/LinkButton';
// import StyledInfoFlash from '/shared/styled/StyledInfoFlash';
// import StyledHeading from '/shared/styled/components/StyledHeading';
// import ReportingPeriod from '/business/shared/components/widgets/reporting-period/ReportingPeriod';

interface SharedVehicleLookupOptions {
  applicationDealershipName?: string | null;
  applicationId?: number | string | null;
  inputLabel: string;
  prependCarField?: boolean;
  prependTaxiField?: boolean;
}

export default function useGetSharedVehicleLookup({
  inputLabel,
  prependTaxiField = false,
  applicationDealershipName,
  applicationId,
  prependCarField = false,
}: SharedVehicleLookupOptions) {
  const { t } = useTranslation();
  const { distanceUnit } = useGetDefaultDistanceUnit();
  const { methodologyStatement } = useGetBusinessDocuments();
  const [valueUnit, setValueUnit] = useState<string | null>(null);

  // TODO: [WR] we might need it. Check with UX
  const quantity = useMemo(() => {
    return {
      element: 'quantity',
      propName: 'distanceTravelled',
      type: FIELD_TYPE_NUMBER,
      placeholderI18nKey: '0',
      styleInputParentWidth: '20rem',
      dropdown: {
        defaultValue: distanceUnit,
        values: [
          {
            name: 'km',
            displayName: 'km',
          },
          {
            name: 'miles',
            displayName: 'miles',
          },
        ],
        propName: 'distanceTravelledUnit',

        element: `${inputLabel}-dropdown`,
        validation: [],
      },
      label: inputLabel,
      labelI18nKey: '',

      validation: [
        {
          rule: ERR_TYPE_REQUIRED,
          errCode: 'ERRQUANTITYREQUIRED',
          errStr: 'Please enter a valid distance',
        },
        {
          rule: ERR_TYPE_NUM_SMALL,
          errCode: 'ERRQUANTITYTOOLOW',
          errStr: 'Please enter a valid distance',
          value: 0,
        },
        {
          rule: ERR_TYPE_NUM_LARGE,
          errCode: 'ERRQUANTITYTOOHIGH',
          errStr: 'Please enter a valid distance',
          value: 999999,
        },
      ],
    };
  }, [inputLabel, setValueUnit, valueUnit, distanceUnit]);

  const dataSource = useMemo(() => {
    return {
      type: FIELD_TYPE_TXTAREA,
      propName: 'dataSource',
      element: 'data_source',
      labelI18nKey: 'business:QuestionPage.forms.refrigerants.para6',
      descriptionI18nKey: 'business:QuestionPage.forms.refrigerants.para7',
      validation: [
        {
          rule: ERR_TYPE_REQUIRED,
          errCode: 'ERRDATASOURCE',
          errStr: t('business:Errors.dataSource.provide'),
        },
        {
          rule: ERR_TYPE_STR_SHORT,
          errCode: 'ERRDATASOURCETOOSHORT',
          errStr: t('business:Errors.dataSource.provide'),
          value: 5,
        },
        {
          rule: ERR_TYPE_STR_LONG,
          errCode: 'ERRDATASOURCETOOLONG',
          errStr: t('business:Errors.dataSource.provide'),
          value: 3000,
        },
      ],
    };
  }, [t]);

  const pageSchema = useMemo<QuestionInputField[]>(() => {
    // if (usePostHead) {
    //   return [posthead, injectedHeader, quantity];
    // }
    return [quantity, dataSource];
  }, [
    // usePostHead,
    quantity,
    dataSource,
    // posthead,
  ]);
  return {
    pageSchema,
    isSingularQuestion: true,
  };
}
